/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import Header from '../directives/header'
import 'react-accessible-accordion/dist/fancy-example.css';
import Footer from './Mrmintnew/directives/footer';


const Tos = () => {


    return (

        <>
            <Header />
            <div id="content" className="tos_p mb-4">
                <div className="breadcrumb-wrap bg-f br-4">
                    <div className="overlay bg-black op-7" />
                    <div className="container">
                        <div className="breadcrumb-title">
                            <h2>Terms Of Use</h2>
                            <ul className="breadcrumb-menu list-style">
                                <li>
                                    <a href="#">Home</a>
                                </li>
                                <li>Terms Of Use</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className='container'>


                    <br />
                    <h4> Mr Mint Token </h4>
                    <p>
                        The content of this website is owned by Mr Mint and is
                        protected by copyright law as a collective work and a compilation. The
                        website https://mrmint.io/ is designed for informational purposes only. We
                        have taken all reasonable care in producing and publishing the information
                        contained on this website. The information is in no way intended to provide
                        financial, tax, accounting, investment, business, or legal advice. In
                        addition, this information should in no way be construed as an offer of
                        securities. Investors are advised to discuss any trading with a registered
                        securities broker or personal finance professional prior to investing.
                        Mr Mint and its officers, directors, subsidiaries,
                        affiliates, contractors, agents, employees, licensors, and/or third-party
                        content providers are in no way responsible or liable for any damages
                        whether they be direct, indirect, consequential, incidental, punitive,
                        exemplary or general damages, contribution or indemnity, of any kind
                        whatsoever, however caused, including loss of profits, caused by or arising
                        from, or reliance on the information contained herein the links to other
                        sites as contained in this website or any information on such sites, or any
                        delays, inaccuracies, errors or omissions in the information contained on
                        this site.
                    </p>
                    <p>
                        No monetary authorities of any other country or jurisdiction have in any way
                        verified or approved this information, and Mr Mint makes
                        no representations or warranties in this regard. Mr Mint
                        has taken all reasonable steps to create and publish the information
                        contained on the website and will strive to do so on a regular basis.
                        However, such information is not intended to provide an exhaustive overview
                        of all issues and events concerning the Company and the Company cannot
                        guarantee the accuracy, relevance or completeness of the information at all
                        times.
                    </p>
                    <p>
                        The sale of the Mr Mint Token does not apply to United States, PRC, Iran,
                        Singapore citizens, legal entities, or companies with US, PRC, Iran,
                        Singapore capital. If an individual or legal entity associated with the
                        United States purchases a Mr Mint Token, that person is personally
                        responsible for the purchase made. Any claim by US, PRC, Iran, Singapore
                        regulators against Mr Mint will be void. Mr Mint is not responsible for the actions of US, PRC, Iran,
                        Singapore citizens, but will endeavor to properly verify the citizenship of
                        its customers and, if a link to the US is found, promises to bar the
                        customer from purchasing tokens. The materials on the website may still
                        contain technical or other inaccuracies, omissions or typographical errors
                        for which Mr Mint is not responsible. Mr Mint does not guarantee or make any representations about the
                        use, validity, accuracy, completeness or reliability of any statements or
                        information on the site.
                    </p>
                    <p>
                        Terms of Use (the term “Use” will mean any access, download, reproduction,
                        installation, copying, demonstration and / or other use, as the case may be)
                        of our Mr Mint Token and related services that allow to issue, manage,
                        transfer lease and exchange tokens, as well as exchange other tokens for
                        tokens. Please read these Terms of Use carefully before using Mr Mint Token.
                        These Terms of Use form a binding Agreement between Mr Mint (“Company”, “us”, “we”) and you as a User. The term “You” or “User”
                        refers to any person or entity browsing, accessing, downloading, reproducing
                        tokens. A copy of these Terms of Use may be downloaded, saved and printed
                        for your reference.
                    </p>
                    <br />
                    <p>
                        IF YOU DO NOT ACCEPT AND AGREE TO BE BOUND BY THESE TERMS OF USE, PLEASE DO
                        NOT ACCESS OUR SITE, USE OR BUY Mr MINT TOKEN. THE COMPANY BELIEVES THAT THE
                        INFORMATION PRESENTED IS ACCURATE AND THAT IT WAS OBTAINED FROM SOURCES THAT
                        THE COMPANY BELIEVES TO BE RELIABLE. HOWEVER, THE COMPANY DOES NOT GUARANTEE
                        THE ACCURACY OR COMPLETENESS OF THE INFORMATION. SUCH INFORMATION MAY CHANGE
                        WITHOUT PRIOR NOTICE. DECISIONS TO USE, HOLD, TRANSFER, TRADE OR MAKE OTHER
                        TRANSACTIONS WITH CRYPTO-ASSETS INVOLVE HIGH DEGREE OF RISK AND ARE BEST TO
                        BE MADE BASED ON THE ADVICE OF QUALIFIED FINANCIAL PROFESSIONALS. ANY
                        DEALINGS WITH CRYPTOCURRENCIES AND OTHER CRYPTO-ASSETS INVOLVE A RISK OF
                        SUBSTANTIAL LOSSES. BEFORE UNDERTAKING ANY ACTION AND USING Mr MINT TOKEN WE
                        STRONGLY ADVICE YOU CONSULT A QUALIFIED FINANCIAL PROFESSIONAL. PLEASE
                        CONSIDER CAREFULLY WHETHER SUCH INVESTING IS SUITABLE FOR YOU IN LIGHT OF
                        YOUR FINANCIAL CONDITION AND ABILITY TO BEAR FINANCIAL RISKS. UNDER NO
                        CIRCUMSTANCES WILL WE BE LIABLE FOR POSSIBLE NEGATIVE CONSEQUENCES THAT YOU
                        OR SOMEONE ELSE WILL INCUR AS A RESULT OF ANY CRYPTO-TRANSFER AND / OR
                        EXCHANGE OR INVESTMENT ACTIVITY.
                        <br />
                        You hereby confirm and warrant that you are fully able and competent to
                        enter into the terms, conditions, obligations, affirmations,
                        representations, and warranties set forth in these Terms and to abide by and
                        comply with these Terms. By using the Mr Mint Token you confirm that:
                    </p>
                    <ul>
                        <li>you are at least 18 (eighteen) years old </li>
                        <li>
                            you are of legal age to accept this Agreement according to your residence
                            country legislation
                        </li>
                        <li>
                            you comply with the laws and regulations of your country of residence{" "}
                        </li>
                        <li>
                            you have the full capacity and authority to enter into this Agreement
                        </li>
                        <li>you have the Mr Mint wallet address</li>
                        <li>
                            you agree and understand that you are always responsible for your
                            behavior, actions and omissions
                        </li>
                        <li>
                            you agree to indemnify and hold harmless the Company and any of its
                            affiliated persons against all suits, claims, costs, losses, damages or
                            demands (including w/r/t property loss, tax claims, infringements of
                            intellectual or personal rights) in case of your non-compliance with these
                            Terms
                        </li>
                    </ul>
                    <br />
                    <p>
                        By entering these Terms and using Mr Mint Token you will warrant and
                        represent that:{" "}
                    </p>
                    <ul>
                        <li>you have full capacity to contract under applicable law</li>
                        <li>
                            you will only be transacting via the Mr Mint Token with legally-obtained
                            funds that belong to you{" "}
                        </li>
                        <li>
                            you will not be performing, undertaking, engaging in, aiding, or abetting
                            any unlawful activity through your relationship with us
                        </li>
                        <li>
                            you will not use the Mr Mint Token for illegal purposes, including money
                            laundering of criminal proceeds, transfer or receipt of payment for
                            planning, preparationor commitment of crime, for financing the terrorism
                            and illegal trade
                        </li>
                        <li>
                            you will not use the Mr Mint Token for any purpose prohibited by these
                            Terms or in any manner that could damage, disable, overburden, or impair
                            the Company
                        </li>
                        <li>
                            you will be complying with and obeying all applicable laws, including but
                            not limited to securities and capital market legislation, anti-money
                            laundering and counterfeiting terrorism, consumer protection laws,
                            financial promotion
                        </li>
                    </ul>
                    <br />
                    <h4>Risk of Blockchain Technology Usage. </h4>
                    <p>
                        You understand that blockchain technologies including Mr Mint Token
                        technology and other associated and related technologies are new, untested
                        and outside of your or the Company’s control and adverse changes in market
                        forces or the technology, broadly construed, may cause the nonperformance by
                        the Company under this Agreement. By utilizing the Mr Mint Token or
                        interacting with the content in any way, you represent that you understand
                        the inherent risks associated with blockchain systems; and warrant that you
                        have an understanding of the usage and intricacies of blockchain-based
                        software systems and crypto tokens.
                    </p>
                    <br />
                    <h4>Volatility of Cryptocurrencies.</h4>
                    <p>
                        You understand that crypto-assets and other blockchain technologies and
                        associated currencies or tokens are highly volatile due to many factors
                        including but not limited to adoption, speculation, regulatory changes,
                        technology, and security risks. Changes in relevant networks may result in
                        sudden changes to the value and/or usability of your crypto-assets. You
                        acknowledge these risks and represent that the Company cannot be held liable
                        for such risks and related costs.
                    </p>
                    <br />
                    <h4>Sophistication.</h4>
                    <p>
                        The services of Mr Mint Token are complex and carry a high level of risk and
                        are not appropriate for Users who do not possess the appropriate level of
                        knowledge and experience to deal with crypto-assets. The Company is not
                        obliged to assess the suitability of the services for Users and any comment
                        or statement which may be made by the Company as to the suitability of the
                        Services to User should under no circumstances be considered as investment
                        or legal advice and should not be received or relied upon as such.
                    </p>
                    <br />
                    <h4>Unfavorable regulatory environment.</h4>
                    <p>
                        Cryptocurrencies and blockchain technologies have been the subject of
                        scrutiny by various regulatory bodies around the world. The functioning of
                        the Mr Mint Token could be impacted by one or more regulatory inquiries or
                        actions, including but not limited to restrictions of use of crypto-assets.
                        The Company and its third party service providers have implemented and
                        maintained commercially reasonable technical and organizational security
                        measures designed to meet the following objectives: (a) ensure the security
                        and confidentiality of your data; (b) protect against anticipated threats or
                        hazards to the security or integrity of your data; (c) protect against
                        unauthorized access or use of your data. However, we cannot guarantee that
                        unauthorized third parties will never be able to circumvent these measures
                        to access your data for inappropriate purposes. Herewith you acknowledge and
                        agree that you access and use the Mr Mint Token at your own risk. The risk of
                        losing the value of held and traded crypto assets can be significant.
                    </p>
                    <p>
                        You agree to release and to indemnify, defend and hold harmlessthe Company
                        and its parents, subsidiaries, affiliates and agencies, as well as the
                        officers, directors, employees, shareholders and representatives of any of
                        the foregoing entities, from and against any and all losses, liabilities,
                        expenses, damages, costs (including attorneys’ fees and court costs) claims
                        or actions of any kind whatsoever arising or resulting from your use of the
                        Mr Mint Token, your violation of these Terms of Use, and any of your acts or
                        omissions that implicate publicity rights, defamation orinvasion of privacy.
                        Company reserves the right, at its own expense, to assume exclusive defense
                        and control of any matter otherwise subject to indemnification by you and,
                        in such case, you agree to cooperate With Company in the defense of such
                        matter.
                    </p>
                    <p>
                        Your use of the Mr Mint Token is at your own risk. In no event will the
                        Company be liable for any direct, indirect, punitive, incidental, special or
                        consequential damages arising out of or in any way connected with the use of
                        the Mr Mint Token, the delay or inability to use Mr Mint Token or otherwise
                        arising in connection with the Mr Mint Token whether based on contract, tort,
                        strict liability or otherwise, even if advised of the possibility of any
                        such damages. You expressly understand and agree that your use of the Mr
                        Mint Token is at your sole risk. Mr Mint Token is provided on an “AS IS” and
                        “as available” basis, without warranties of any kind, either express or
                        implied, including, without limitation, implied warranties of
                        merchantability, fitness for a particular purpose or non-infringement. You
                        acknowledge that Company has no control over, and no duty to take any action
                        regarding: which users gain access to or use the Mr MINT TOKEN; which third
                        party websites and services you use with the help of or through the Software
                        and the Services; how you may use the Mr Mint Token; or what actions you may
                        take with the help of the Mr Mint Token.
                    </p>
                    <p>
                        Unless the contrary is specifically provided in these Terms,any notice,
                        instruction, requestor other communication to be given to us by the User
                        under these Terms shall be in writing and shall be sent to the email address
                        below (or to any other address which we may from time to time specify to the
                        user for this purpose) and shall be deemed delivered only when actually
                        received by us at: support@mrmint.io
                    </p>
                    <p>
                        DISPUTE RESOLUTION, PLACE OF JURISDICTION AND GOVERNING LAW. These Terms
                        shall exclusively be governed by and construed in accordance with the
                        substantive laws of the United Kingdom, as amended from time to time. In the
                        event that the parties are unable to resolve a Dispute, then the parties
                        hereby irrevocably submit such Dispute to the exclusive jurisdiction of the
                        courts ofthe United Kingdom. FORCE MAJEURE. A Force Majeure Event includes
                        without limitation each of the following: Government actions, the outbreak
                        of war or hostilities, the threat of war, acts of terrorism, national
                        emergency, riot, civil disturbance, sabotage, requisition, or any other
                        international disaster, economic or political crisis, Act of God,
                        earthquake, tsunami, hurricane, typhoon, accident, storm, flood, fire,
                        epidemic or other natural disaster, labor disputes and lock-out, breakdown,
                        failure or malfunction of any electronic network and communication lines
                        (not due to our fault), any event, the circumstances of the entity that we
                        cannot reasonably control, and the consequences of this event (s) are such
                        that Mr Mint support team is unable to take any
                        reasonable action to correct the situation.
                    </p>
                    <p>
                        Entire Agreement/assignment/these terms (and any additional terms, rules and
                        conditions of participation that Company may post with respect to provision
                        of the Mr Mint Token) constitute the entire Agreement between you And Company
                        with respect to the Mr Mint Token and supersedes any prior agreements, oral
                        or written, between you and Company. In the event of a conflict between
                        these Terms and the additional terms, rules and conditions of participation,
                        the latter will prevail over the Terms to the extent of the conflict. We may
                        assign these Terms to our parent company, affiliate or subsidiary, or in
                        connection with a merger, consolidation, or sale or other disposition of all
                        or substantially all of its assets.
                    </p>
                    <p>
                        The Company’s failure to exercise or enforce any right or provision of the
                        Terms does not constitute a waiver of such right or provision. If any
                        provision of the Terms is found by an arbitrator or court of competent
                        jurisdiction to be invalid, the parties nevertheless agree that the
                        arbitrator or court should endeavor to give effect to the parties’
                        intentions as reflected in the provision, and the other provisions of the
                        Terms remain in full force and effect.
                    </p>
                    <p>
                        You bear the sole responsibility to determine if your use of the Mr
                        Mint Token and/or any other action or transaction you made through have tax
                        implications for you and for payment of all applicable taxes. By using the
                        Mr Mint Token, and to the extent permitted by law, you agree not to hold us
                        liable for any tax liability associated with or arising from the operation
                        of the Company or any other action or transaction related to Mr Mint Token.
                    </p>
                    <p></p>
                    <p>
                    you acknowledge and agree that you assume full responsibility for your use of the Mr Mint Token. you acknowledge and agree that any information you send or receive during your use of Mr Mint Token may not be secure and may be intercepted or later acquired by unauthorized parties. you acknowledge and agree that your use of the Mr Mint Token is at your own risk. recognizing such, you understand and agree that, to the fullest extent permitted by applicable law, neither company nor its affiliated persons or representatives will be liable to you for any direct, indirect, incident connect, special, any kind, including without limitation damages for loss of profits, goodwill, use, data or other tangible or intangible losses or any other damages based on contract, tort, strict liability or any other damages resulting from the service; the use of the Mr Mint Token; unauthorized access to or alteration of your transmissions or data; statements or conduct of any third party on the Mr Mint Token; any actions we take or fail to take as a result of communications you send to us; human errors; technical malfunctions; failures, including public utility or internet outages; omissions, interruptions, latency, deletions or defects of any device or network, providers, or software; any injury or damage to computer equipment; inability to fully access the Mr Mint Token or use the Mr Mint Token; theft, tampering, destruction, or unauthorized access to, images or other content of any kind; data that is processed late or incorrectly or is incomplete or lost; typing, printing or other errors, or any combination thereof; or any other matter relating to Mr Mint Token.
                    </p>
                    <br />
                </div>




            </div>
            <Footer />
        </>

    )

}
export default Tos;